import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from 'loyal-react'

export default function Home () {
  return (
    <React.Fragment>
      <div className='p-2 position-relative'>
        <div className='d-flex col-12 justify-content-between flex-column flex-md-row'>
          <div className='col-12 col-md-7 p-0'>
            <h2 className='my-3'>Onde usar seu cartão?</h2>
            <div className='d-flex justify-content-between flex-wrap like-plus-cart'>
              <div className='col-md-4 col-5 py-2 p-0 d-flex flex-column'>
                <Icon
                  iconName='icon_mastercard'
                  className='color-brand-2-like mb-2 icon-size-40'
                />
                <p className='col-11 p-0'>Estabelecimentos de rede Mastercard</p>
              </div>

              <div className='col-md-4 col-5 py-2 p-0 d-flex flex-column'>
                <Icon
                  iconName='icon_play'
                  className='color-brand-2-like mb-2 icon-size-40'
                />
                <p className='col-11 p-0'>Assine serviços de séries e filmes</p>
              </div>

              <div className='col-md-4 col-5 py-2 p-0 d-flex flex-column'>
                <Icon
                  iconName='icon_airplane'
                  className='color-brand-2-like mb-2 icon-size-40'
                />
                <p className='col-11 p-0'>Use nas viagens internacionais</p>
              </div>
              <div className='col-md-4 col-5 py-2 p-0 d-flex flex-column'>
                <Icon
                  iconName='icon_game'
                  className='color-brand-2-like mb-2 icon-size-40'
                />
                <p className='col-11 p-0'>Aproveite os games mais legais</p>
              </div>
              <div className='col-md-4 col-5 py-2 p-0 d-flex flex-column'>
                <Icon
                  iconName='icon_shop'
                  className='color-brand-2-like mb-2 icon-size-40'
                />
                <p className='p-0'>Compre em supermercado</p>
              </div>
              <div className='col-md-4 col-5 py-2 p-0 d-flex flex-column'>
                <Icon
                  iconName='icon_label'
                  className='color-brand-2-like mb-2 icon-size-40'
                />
                <p className='col-11 p-0'>Compre em qualquer site do mundo</p>
              </div>
            </div>
          </div>

          <div className='position-absolute col-md-4 col-12 p-0 likeplus-lateral-menu mt-2 mt-md-0'>
            <div className='bg-ui-5 col-12 mb-2 p-2 d-flex align-items-center'>
              <Icon
                iconName='icon_headphone'
                className='color-brand-2-like mr-2'
              />
              <div>
                <p className='mt-half txt-body-sm'>
                  <span>Central de atendimento</span>
                </p>
                <p>
                  <strong>3003-4455</strong>
                </p>
              </div>
            </div>
            <div className='bg-ui-5 col-12 p-2 d-flex flex-column'>
              <div >
                <h3 className='h5'>Benefícios Like Mais</h3>
              </div>

              <div className='mt-2 col-10 p-0'>
                <p>
                  <strong>Não importa onde você esteja</strong>
                </p>
                <p>Se precisar de dinheiro, saque na hora. Sem burocracia nem conta bancária</p>
              </div>

              <div className='col-10 mt-2 p-0'>
                <p>
                  <strong>Recarga fácil</strong>
                </p>
                <p>Você recarrega o seu cartão sem valor mínimo, nem custos adicionais.</p>
              </div>

              <div className='col-10 mt-2 p-0'>
                <p>
                  <strong>Compre onde e quando você quiser</strong>
                </p>
                <p>Seja online ou em loja física, seu cartão é aceito em toda rede Mastercard@</p>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className='col-12 border-color-ui-3 bg-white border d-flex align-items-center justify-content-center'>
        <div className='col-md-4 col-12 py-2'>
          <Link
            className='btn btn-sm d-block btn-featured txt-button txt-center txt-font-body'
            to='/like-plus'
            role='button'>
              Peça já o seu cartão like mais
          </Link>
        </div>
      </div>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/Home/Home.js